<template>
	<div>
		<div style="height: 400px;">
			<div class="zhutu-box">
				<vue-photo-zoom-pro :high-url="imgsData[showBigIndex]">
				  <img :src="imgsData[showBigIndex]" alt="">
				</vue-photo-zoom-pro>



			</div>


		</div>

		<div class="picbox" id="sliderImgs">

			<a class="prev img-arrow-left" href="javascript:void(0)"></a>
			<div class="bds">

				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in imgsData" :key="index" @click="slideClick(index)" :class="{'slide-active': showBigIndex == index}">
							<img :src="item" />
						</div>

					</div>



				</div>



			</div>
			<a class="next img-arrow-right" href="javascript:void(0)"></a>

		</div>

		<div class="collection">

		    <span class="collection-tip">图片仅供参考，订单以产品编码为准</span>
		</div>
	</div>
</template>

<script>
	import Swiper from 'swiper';
	import 'swiper/dist/css/swiper.min.css'
	import 'swiper/dist/js/swiper.min.js'
	import VuePhotoZoomPro from 'vue-photo-zoom-pro'
	import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'

	export default {
		components: {
		  VuePhotoZoomPro
		},
		name: 'zhutu',
    props: {
      imgsData: {
        type: Array,
        default: []
      }
    },
		data() {

			return {
				swiper: null,
				// imgsData: [
				// 	"https://cdn.oudianyun.com/back-manage-web/1662704801848_57.651205933272365_e4891014-895f-42da-8b64-8162348acb4b.png",
				// 	"https://cdn.oudianyun.com/back-manage-web/1667733036563_87.10044769226786_0b7c4872-fe38-4954-93fe-17848dca241f.png",
				// 	"https://cdn.oudianyun.com/back-manage-web/1667733036563_87.10044769226786_0b7c4872-fe38-4954-93fe-17848dca241f.png",
				// 	"https://cdn.oudianyun.com/back-manage-web/1662704801848_57.651205933272365_e4891014-895f-42da-8b64-8162348acb4b.png",
				// 	"https://cdn.oudianyun.com/back-manage-web/1667733036563_87.10044769226786_0b7c4872-fe38-4954-93fe-17848dca241f.png",
				// 	"https://cdn.oudianyun.com/back-manage-web/1667733036563_87.10044769226786_0b7c4872-fe38-4954-93fe-17848dca241f.png"
        //
				// ],
				showBigIndex: 0,


			}
		},
		mounted() {
			var that = this

			this.$nextTick(() => {
				that.swiper = new Swiper('.swiper-container', {
					spaceBetween: 10,
					slidesPerView: 5,


					navigation: {
						nextEl: '.next',
						prevEl: '.prev',
					},

				});

			})
		},
		methods: {
			slideClick(i){
				this.showBigIndex=i
				this.swiper.slideTo(i)
			}
		},

	}
</script>

<style scoped="scoped" lang="less">
	.swiper-button-disabled{
		opacity: .3;
	}
	.zhutu-box {
		width: 398px;
		height: 398px;
		border: 1px solid #EEEEEE;
    display: flex;
    align-items: center;
    justify-content: center;
		.bd,
		ul,
		li,
		a,
		img {
			display: block;
			width: 398px;
			height: 398px;
		}
    img{
      width: 100%;
      height: 100%;
      max-width: 398px;
      max-height: 398px;
      //object-fit: contain;

    }
	}
	.picbox{
		a{
			outline: none;
		}
	}
	.swiper-container,
	.swiper-wrapper,
	.swiper-slide
	{
		height: 64px;
		img{
			width: 100%;
			box-sizing: border-box;
			height: 64px;
			display: block;
			border: 2px solid #fff;
		}
	}
	.slide-active img{
		border-color: #57ACA7;
	}
	.picbox {
		margin: 6px 0;
	}

	.small-box {

		li {
			float: left;
			width: 64px;
			height: 64px;
			margin-right: 10px;
		}

		img {
			width: 60px;
			height: 60px;
			display: block;
			border: 2px solid #fff;
      object-fit: contain;
      background: #fff;
		}

		li.on img {
			border-color: #57ACA7;
		}
	}
  .bds{
    img{
      object-fit: contain;
      background: #fff;

    }

  }

	.picbox {
		position: relative;
		padding: 0 18px;
		height: 64px;

		.bd2 {
			width: 100%;
			height: 64px;
			position: relative;
			overflow: hidden;
		}
	}
</style>
